// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_qk-5";
export var filledCircle = "_qk-4";
export var historyEntry = "_qk-3";
export var messageSideLeft = "_qk-1";
export var messageSideRight = "_qk-2";
export var orderTrackingCarouselWrapper = "_qk-6";
export var orderTrackingInfoContainer = "_qk-0";